<template>
  <div class="bg-f">
    <van-collapse v-model="activeItem" :border="false">
      <div v-for="(deck,index) in decks" :key="deck.id">
        <div class="position-relative">
          <van-collapse-item v-if="deck.decks" :name="deck.id" :border="false" :is-link="deck.is_link">
            <div :style="'width:'+width+'px'" slot="title">
              <div :title="index.length>10?index:''" class="fs-14 c-5 text-ellipsis-1"
                   :class="level >= 0?'text-strong':'h-0 lh-0'">
                <span :class="{'text-strong':activedid == deck.id}">{{ deck.simpleName }}</span>
              </div>
            </div>
            <deck-item class="mg-l-10" :activedid="activedid" :open="open"
                       :decks="deck.decks" :level="level + 1">
            </deck-item>
          </van-collapse-item>
          <div style="cursor: pointer;" class="mg-l-10" v-else>
            <div :style="'width:'+width+'px'" class="mg-b-10">
              <div class="fs-14 c-5 text-ellipsis-1">
                <span>{{ deck.simpleName }}</span>
              </div>
            </div>
          </div>
          <div class="position-absolute r-30 c-b fs-12 pd-t-2 t-2">
            <div>{{ deck.totalCard }}</div>
          </div>
        </div>
      </div>
    </van-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: 230,
      activeItem: []
    }
  },
  props: {
    decks: {
      type: Object,
      default: null
    },
    level: {
      type: Number,
      default: 1
    },
    activedid: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  name: "deckItem",
  methods: {},
  mounted() {
    console.log(this.decks)
    if (this.open) {
      this.activeItem = [];
      if (this.decks && this.level < 2) {
        for (let k in this.decks) {
          this.activeItem.push(this.decks[k].id);
        }
      }
    }
  }
}
</script>

<style scoped>

::v-deep .van-cell {
  padding: 0px 5px 10px 10px !important;
}

::v-deep .van-collapse-item__content {
  padding: 0 0 5px 10px !important;
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
}
</style>
